import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseTableNew from 'components/atoms/base-table/new';
import useUpdateEffect from 'infrastructure/hooks/utils/use-update-effect';
import { useManualClinicNotesLog } from 'infrastructure/hooks/logs/use-manual-clinic-notes-log';

import { manualClinicNotesLogColumns } from './cols';
import s from './styles.module.scss';

import type { DateRange } from 'infrastructure/types';
import type { ModuleType } from 'infrastructure/enums';

interface IPatientManualClinicNotesLogProps {
  patientGuid: string;
  module: ModuleType;
  dateRange?: DateRange;
}

const PatientManualClinicNotesLog: React.FC<
  IPatientManualClinicNotesLogProps
> = (props) => {
  const { patientGuid, module, dateRange } = props;

  const { t } = useTranslation();

  const { loading, items, meta, setMeta } = useManualClinicNotesLog({
    patientGuid,
    meta: {
      dateRange,
      module,
    },
  });

  const onChangePage = (page: number) => {
    setMeta({
      ...meta,
      page,
      dateRange,
      module,
    });
  };

  useUpdateEffect(() => {
    setMeta({
      ...meta,
      page: 1,
      dateRange,
    });
  }, [dateRange]);

  return (
    <div className={s.wrapper}>
      <h3 className={s.title}>{t('labels.manualClinicNotesLogged')}</h3>
      <BaseTableNew
        dataCy="manual-clinic-notes-log-table"
        rowKey="key"
        columns={manualClinicNotesLogColumns()}
        items={items}
        loading={loading}
        pagination={{
          current: meta.page,
          pageSize: meta.items,
          total: meta.totalCount,
        }}
        onChangePage={onChangePage}
        bordered
      />
    </div>
  );
};

export default React.memo(PatientManualClinicNotesLog);
